import Accordion from "@/components/Accordion";
import React from "react";
import { BookAppointment } from "./BookAppointment";
import { Content } from "./Content";
import { CustomAction } from "./CustomAction";
import { ChatWindow } from "../../types";
import { ClickToCall } from "./ClickToCall";
import { QuickTicket } from "./QuickTicket";
import { RequestCall } from "./RequestCall";
import { AvatarLauncher } from "./AvatarLauncher";
import useSubscriptions from "@/hooks/useSubscriptions";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedContentWidgetImageFile: (file: File | null) => void;
  onScreenChange: (screen: string) => void;
}

export default function Widgets({ workingChatWindow, setWorkingChatWindow, setStagedContentWidgetImageFile, onScreenChange }: Props) {
  const { subscription } = useSubscriptions();

  return (
    <div className="bg-white rounded-2xl shadow-md w-full border p-6 pb-8">
      <div className="text-lg font-medium mb-2">Chat Cards</div>
      <div className="text-sm font-normal text-slate-600 mb-4">
        Customize your chat window with interactive cards. Chat Cards are
        customizable cards for quick access to key features.
      </div>
      <div className="overflow-auto">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-600 mb-2">
          Chat Cards
        </div>
        <Accordion>
          <BookAppointment
            onExpanded={() => onScreenChange("Calendly")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
          />
          <ClickToCall
            onExpanded={() => onScreenChange("Landing")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
          />
          <Content
            onExpanded={() => onScreenChange("Content")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
            setStagedContentWidgetImageFile={setStagedContentWidgetImageFile}
          />
          <CustomAction
            onExpanded={() => onScreenChange("CustomAction")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
          />
          <QuickTicket
            onExpanded={() => onScreenChange("QuickTicket")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
          />
          <RequestCall
            onExpanded={() => onScreenChange("RequestCall")}
            workingChatWindow={workingChatWindow}
            setWorkingChatWindow={setWorkingChatWindow}
          />
          {subscription?.enableAvatarMode && (
            <AvatarLauncher
              onExpanded={() => onScreenChange("Avatar")}
              workingChatWindow={workingChatWindow}
              setWorkingChatWindow={setWorkingChatWindow}
            />
          )}
        </Accordion>
      </div>
    </div>
  );
}
